module.exports = __webpack_public_path__ + "img/tech.77b6f32c.svg";